import { render, staticRenderFns } from "./NostoCategory.vue?vue&type=template&id=48d3e476&"
import script from "./NostoCategory.vue?vue&type=script&lang=ts&"
export * from "./NostoCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports